(function($) {

    var navButton = $('.mobile-nav-button'),
        navContainer = $('.slide-navigation'),
        navWrapper = $('.main-nav-wrapper');

    var bodyHeightRestore;

    var initFlag = false;

    var mobileNavigation = {

        isSlideVisible: function() {
            return navContainer.is(':visible');
        },

        /**
         * Устанавливается размеры для body и для контейнера навигации исходя из текущей высоты окна
         */
        fixHeights: function() {

            if (!this.isSlideVisible()) return;

            navWrapper.css({
                'max-height': $(window).height() + 'px'
            });

            $('body').height($(window).height()).css({
                'overflow-y': 'hidden'
            });

        },


        /**
         * Открывает меню
         */
        open: function() {
            var self = this;

            if (!navButton.is(':visible')) return;
            if (navWrapper.hasClass('active')) return;

            navContainer.fadeIn(50, function() {
                navWrapper.addClass('active');
                self.fixHeights();
            });
        },

        /**
         * Закрывает меню
         */
        close: function() {
            $('body').css('height', 'auto');
            navContainer.fadeOut(50, function() {
                navWrapper.removeClass('active');
            });

            $('body').css({
                'overflow-y': 'auto'
            });
        },

        navButtonClickHandler: function() {
            this.open();
        },

        containerClickHandler: function(e) {
            if (e.target == navContainer.get(0)) {
                this.close();
            }
        },

        init: function() {
            if (window.innerWidth >= 992) return;
            if (initFlag) return;

            var self = this;

            navButton.click(function() {
                self.navButtonClickHandler()
            });

            navContainer.click(function(e) {
                self.containerClickHandler(e)
            });

            $(window).resize(function() {
                self.fixHeights();
            });

            var hammer = new Hammer(document.body);

            // listen to events...
            hammer.on('swipeleft swiperight', function(ev) {

                if (ev.type == 'swipeleft') {
                    self.close();
                }

                if (ev.type == 'swiperight') {
                    self.open();
                }

            });
        }

    };

    $(document).ready(function() {
        $(window).resize(function() {
            mobileNavigation.init();
        });
        mobileNavigation.init();
    });



})(jQuery);
